var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40C0 62.04 17.96 80 40 80C45.52 80 50 75.52 50 70C50 67.56 49.08 65.2 47.44 63.32C47.12 62.92 46.92 62.48 46.92 62C46.92 60.88 47.8 60 48.92 60H56C69.24 60 80 49.24 80 36C80 16.16 62.04 0 40 0C17.96 0 0 17.96 0 40ZM8 40C8 22.36 22.36 8 40 8C57.64 8 72 20.56 72 36C72 44.84 64.84 52 56 52H48.92C43.4 52 38.92 56.48 38.92 62C38.92 64.4 39.8 66.76 41.44 68.6C41.68 68.88 42 69.36 42 70C42 71.12 41.12 72 40 72C22.36 72 8 57.64 8 40ZM18 32C14.6863 32 12 34.6863 12 38C12 41.3137 14.6863 44 18 44C21.3137 44 24 41.3137 24 38C24 34.6863 21.3137 32 18 32ZM24 22C24 18.6863 26.6863 16 30 16C33.3137 16 36 18.6863 36 22C36 25.3137 33.3137 28 30 28C26.6863 28 24 25.3137 24 22ZM50 16C46.6863 16 44 18.6863 44 22C44 25.3137 46.6863 28 50 28C53.3137 28 56 25.3137 56 22C56 18.6863 53.3137 16 50 16ZM56 38C56 34.6863 58.6863 32 62 32C65.3137 32 68 34.6863 68 38C68 41.3137 65.3137 44 62 44C58.6863 44 56 41.3137 56 38Z",
    fill: "#C1C2C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.4476baf1.svg";
export { ForwardRef as ReactComponent };